import { Button } from '@athena/forge';
import Banner from '../common/Banner';
import { I18N_MAPPING } from '../../constants';
import athenaConfig from '../../config';

export default function BlockProdUserPasswordResetInSupportBanner() {
  return (
    <Banner alertType='critical' headerText={I18N_MAPPING.en['password.reset.environment.error.header']}>
      {I18N_MAPPING.en['password.reset.environment.error']}
      <Button variant="tertiary" size="small" onClick={() => window.open(athenaConfig.prodAOneBaseUrl, '_blank')} style={{ fontSize: 'inherit' }}>{I18N_MAPPING.en['password.reset.environment.athenaone.production']}</Button>
    </Banner>
  );
}
